import { useUtils } from "@/app/hooks/useUtils";
import clsx from "clsx";

const PetAge: React.FC<{
  dob: string; //YYYY-MM-DD
  className?: string;
}> = (props) => {
  const { DOBToAge } = useUtils();
  const age = DOBToAge(props?.dob);
  return props?.dob === null ? (
    <span className="text-red-500 text-[10px] sm:text-xs 2xl:text-sm">No Age</span>
  ) : (
    <span
      className={clsx(props?.className, "text-[10px] sm:text-xs 2xl:text-sm")}
    >{`${age?.years ? `${age?.years} Year(s)` : "0 Y"} ${age?.months ? `${age?.months} Month(s)` : "0 M"}`}</span>
  );
};

export default PetAge;
